interface VideoDetailsCardProps {
  duration: string;
  frames: string;
  // fps: string;
  // condition: string;
}

function VideoDetailsCard({
  duration,
  frames,
  // fps,
  // condition,
}: VideoDetailsCardProps) {
  const items = [
    { label: "Duration", value: duration },
    { label: "Frames", value: frames },
    // { label: "FPS", value: fps },
    // { label: "Condition", value: condition },
  ];

  return (
    <section>
      <h3 className="sidebar-heading">VIDEO DETAILS</h3>

      <div className="info-grid">
        {items.map((item) => (
          <div key={item.label} className="info-card">
            <span className="info-label">{item.label}</span>
            <strong className="info-value">{item.value}</strong>
          </div>
        ))}
      </div>
    </section>
  );
}

export default VideoDetailsCard;